<template>
  <div id="app">
    <!---->
    <div class="index">
      <Header-el></Header-el>
      <div class="searchquestion">
        <div class="clearfix searcharea">
          <input type="text" v-model="d_helpsearchval" placeholder="请输入你想咨询的问题......" @keyup.enter="helplistbtn" autofocus="autofocus" class="fl" />
          <button class="fl" @click="helplistbtn">搜 索</button>
          <div class="searchresult" v-show="d_searchhelpshow">
            <ul class="searchlist" style="display: none;" v-show="d_searchheldata.length>0">
            <li v-for="(helplist,helpindex) in d_searchheldata" v-bind:key="helpindex">
              <a :href="'/helpshow/'+helplist.ID" v-text="helplist.Title"></a>
            </li>
            </ul>
            <span style="display:none;" v-show="d_searchheldata.length==0">没有找到相关问题哦。。。</span>
          </div>
        </div>
      </div>
      <!--<div class="guide">-->
        <!--<h4 class="title">新手引导</h4>-->
        <!--<ul>-->
          <!--<li>-->
            <!--<a href="#">-->
              <!--<img src="http://images.kaishiba.com/20180226bzzx6.png" />-->
              <!--<h6>关于我们</h6>-->
              <!--<p>快速了解星达，一起来造</p>-->
            <!--</a>-->
          <!--</li>-->
          <!--<li></li>-->
          <!--<li>-->
            <!--<a href="#">-->
              <!--<img src="http://images.kaishiba.com/20180226bzzx5.png" />-->
              <!--<h6>发起人指南</h6>-->
              <!--<p>项目流程清晰了解，快速发起</p>-->
            <!--</a>-->
          <!--</li>-->
          <!--<li></li>-->
          <!--<li>-->
            <!--<a href="#">-->
              <!--<img src="http://images.kaishiba.com/20180226bzzx8.png" />-->
              <!--<h6>共建人指南</h6>-->
              <!--<p>共建流程快速掌握，轻松参与</p>-->
            <!--</a>-->
          <!--</li>-->
        <!--</ul>-->
      <!--</div>-->
      <div class="selfhelp">
        <h4 class="title">自助服务</h4>
        <div>
          <div class="helplist">
            <ul class="clearfix titles">
              <li class="fl" v-for="(category,index) in categoryData" v-bind:key="index" :class="{'active':index==categoryactive}"  v-on:click="helplisttab(category,index);">
                {{category.Name}}
                </li>
            </ul>
            <ul class="clearfix questions" style>
              <li class="fl" v-for="help in helpData" v-bind:key="help.ID">
                <a :href="'/helpshow/'+help.ID">{{help.Title}}</a>
                <!---->
              </li>
            </ul>
            <div class="showmore" v-show="d_showmore" @click="morecaredata">
              <span>展开更多</span>
              <img src="http://images.kaishiba.com/20180226bzzx7.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="mailus">
        <h4 class="title">没有找到答案？</h4>
        <p>
          <span>您可以联络我们获取更多信息。如没有找到您需要的问题，请邮件留言至</span>
          <a href="mailto:service@asstar.com">service@asstar.com</a>
        </p>
        <a href="mailto:service@asstar.com" class="mailbutton">联系我们</a>
      </div>
      <navshare-el/>
    </div>
      <Footer-el></Footer-el>
  </div>
</template>

<style scoped>
@import url("../css/help.css");
</style>
<script>
import Header from "../components/header";
import Footer from "../components//footer";
import NavShare from "../components/navShare";
export default {
  name: "app",
  data() {
    return {
      categoryData: [{ ID: "1", Name: "aaa" }],
      helpData: [],
      helpFilter: {
        Pager: { PageNumber: 1, PageSize: 10 },
        CategoryID: { Value: "" }
      },
      categoryactive:0,
      d_showmore:false,
      d_moredataindex:1,
      d_catepagecount:1,
      d_helpsearchval:'',
      d_searchheldata:[],
      d_searchhelpshow:false
    }
  },
  components: {
    "Header-el": Header,
    "Footer-el": Footer,
    "navshare-el":NavShare
  },
  watch:{
    d_helpsearchval (val) {
      var t = this
      if(val=="") {
        t.d_searchhelpshow = false
        t.d_searchheldata = []
      }
    }
  },
  methods: {
    //帮助模糊搜索
    helplistbtn:function() {
      var t = this
      t.d_searchhelpshow = true
       t.helpFilter= {
        Pager: { PageNumber: 1, PageSize:100 },
        CategoryID: { Value:null },
        title:{Value:t.d_helpsearchval,Mode:0}
      }
      T.post("/api/help/list", this.helpFilter, function(data) {


          t.d_searchheldata = data.Results
          console.log(t.d_searchheldata)

      })


    },
    //更多展示
    morecaredata:function() {
      var t = this
      t.d_moredataindex += 1
      if(t.d_moredataindex>t.d_catepagecount) {
        return;
      }
      this.helpFilter.Pager.PageNumber = t.d_moredataindex
       T.post("/api/help/list", this.helpFilter, function(data) {
        data.Results.forEach(function(val) {
          t.helpData.push(val)
        })
        t.d_catepagecount = data.PageCount
        if(t.d_moredataindex<data.PageCount) {
          t.d_showmore=true
        }else {
          t.d_showmore=false
        }
      });
    },
    helplisttab:function(val,ind) {

       this.helpFilter.CategoryID.Value=val.ID;
       this.categoryactive=ind;
       console.log(this.categoryactive)
       this.loadHelp()
    },
    loadCategory: function() {
      var _self = this;
      // this.get("/api/help/category/get", "GET", "", function(data) {
      //   console.log(data);
      //   _self.categoryData = data;
      // });
      T.get("/api/help/category/get", function(data) {
        console.log(data)
        _self.categoryData = data.Data;
      });
    },
    loadHelp: function() {
      var _self = this;
      // this.get("/api/help/list", "post", this.helpFilter, function(data) {
      //   console.log(data);
      //   _self.helpData = data;
      // });
      this.helpFilter.Pager.PageNumber = 1
      T.post("/api/help/list", this.helpFilter, function(data) {

        _self.helpData = data.Results;
        _self.d_catepagecount = data.PageCount
        console.log(data.PageCount)
        if(data.PageCount>1) {
          _self.d_showmore=true
        }else {
          _self.d_showmore=false
        }
      });

      // if (this.helpFilter.CategoryID != null)
      //   this.categoryactive = this.helpFilter.CategoryID.Value;
    }
  },
  created() {
    this.loadCategory();
    this.loadHelp();
  }
};
</script>
